export const FIREBASE_CONFIG = process.env.REACT_APP_FIREBASE_CONFIG;
export const FIREBASE_LOG_EVENTS = process.env.REACT_APP_FIREBASE_FIRESTORE_LOG;

export const FIREBASE_EVENT_CATEGORY = {
    DeviceDetails: "DeviceDetails",
    UploadFiles: "Upload files",
    ImageCompression: "ImageCompression",
    Flash: "Flash",
    HOST_CONTROLLED_PARTICIPANTS: "HOST_CONTROLLED_PARTICIPANTS",
    NOTIFICATION_TOAST: "NOTIFICATION_TOAST",
    REQUEST_MIC_CAMERA: "REQUEST_MIC_CAMERA",
    TwilioTelemetry: "TwilioTelemetry",
    ChatTranslation: "ChatTranslation",
};

export const FIREBASE_LOG_KEY = {
    FromDevice: "from device",
    FromCamera: "From Camera",
    SelectImage: "Select image",
    Markup: "markup",
    FileList: "file_list",
    WindowFile: "window_File",
    FileSelect: "file_select",
    SendMessage: "send_msg",
    NavigatorMediaDevices: "navigator.mediaDevices",
    VideoCreationFailed: "FromCamera_video_creation_failed",
    CapturePhotoClicked: "capture_photo_clicked",
    VideoElementNotFound: "video_element_not_found",
    VideoConstraints: "videoConstraints",
    CompressionObj: "compressionObj",
    MinSize: "minSize",
    MaxSize: "maxSize",
    UploadFileRemainingCount: "Sending Upload files remaining count",
    FlashSupportError: "isFlashSupport_error",
    DisabledStatus: "disabled_status",
    ReceivedMessage: "received_msg",
    // Twilio telemetry keys
    TrackWarning: "track_warning",
    VideoDimensionsChanged: "video_dimensions_changed",
    CPUPressure: "cpu_pressure",
    CPUPressureNotSupported: "cpu_pressure_not_supported",
    localTrack_warnings_cleared: "LocalTrack_warnings_have_cleared!",
    // Chat translation keys
    TranslationSettingsChanged: "translation_settings_changed",
    TranslationError: "translation_error",
};

export const FIREBASE_LOG_VALUE = {
    RemovedLargeFiles: "removed more than 20MB file size image",
    MaxUploadLimitReached: "Maximum number of upload files limit reached",
    FileAPINotSupported: "Your browser does not support File API",
    FromCamera: "from_camera",
    FromDevice: "from_device",
    FromUploadButton: "from_upload_button_only",
    UploadFileStartNotification: "Sending Upload files start notification",
    UploadFileEndNotification: "Sending Upload files end notification",
    EnumerateNotSupported: "enumerateDevices() not supported.",
    CameraStreamAvailable: "Camera stream available",
    BackToFinalView: "back to final upload screen without file select",
    BackToMarkupWithoutSelection: "back to markup screen without file select",
    BackToSelectFileWithoutSelection: "back to select screen without file select",
    Clicked: "clicked",
    UploadFileClickedOnMarkup: "upload clicked on markup screen",
    PlusClickWithType: "Plus clicked with type: ",
};
